import axios from "axios";

import { handleError } from "@utils/axios-utils";
import { axiosInstance } from "@utils/axiosInstance";

export const deleteData = async (url: string) => {
  try {
    await axiosInstance.delete(url);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError(error);
    }
  }
};
